


import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


export default {

components: {
Swiper,
SwiperItem,
},
data() {

return {
imgList: [],
hid: this.$route.query.hid,
pid: null, //对应景区的hid
content: "",
address: "",

duration: "00:00", //音频总时长
audioCurTime: "00:00", //音频当前时间
audioSrc: null,
playing: false, //音频播放中的状态
barWidth: 0, //已播放条的宽度值
dotLeft: 0, //进度点的left值

scenicHid: null,
};
},

computed: {},

watch: {},

methods: {
getDetail() {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",

params: { hid: that.hid },
success: function (data) {
console.log(data.data);
let result = data.data.data.hotspot;
let audio = document.getElementById("myaudio");
that.pid = data.data.data.hotspot.pid;
that.imgList = data.data.data.imgList;
that.content = result.description;
that.address = result.address;
that.scenicHid = result.pid;
document.title = result.name;

if (that.imgList.length == 0) {
if (data.data.data.hotspot.thumbImg == null) {

} else {
that.imgList = [{ midImg: data.data.data.hotspot.thumbImg }];
}
}
if (result.audio == "" || result.audio == null) {
that.audioSrc = null;
} else {
that.audioSrc =
that.GLOBAL.DOMAIN_URL + result.audio.split(".")[0] + ".mp3";
audio.load();

audio.addEventListener("canplay", function () {
that.duration = that.commonFun.transTime(audio.duration);
});

if (that.GLOBAL.isWx) {
if (window.WeixinJSBridge) {
WeixinJSBridge.invoke(
"getNetworkType",
{},
function (e) {
that.audioPlay();
},
false
);
} else {
document.addEventListener(
"WeixinJSBridgeReady",
function () {
WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
that.audioPlay();
});
},
false
);
}
}
}
},
isShowLoading: true,
});
},



progressBarBg(e) {
let audio = document.getElementById("myaudio");
if (!audio.paused || audio.currentTime != 0) {

let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.offsetWidth;
let rate = e.offsetX / pgsWidth;
audio.currentTime = audio.duration * rate;
this.updateProgress(audio);
}
},



progressDot(e) {
let that = this;
let audio = document.getElementById("myaudio");
let dot = document.getElementById("progressDot");
if (!audio.paused || audio.currentTime != 0) {
let oriLeft = dot.offsetLeft;
let mouseX = e.clientX;
let maxLeft = oriLeft; 
let maxRight =
document.getElementById("progressBarBg").offsetWidth - oriLeft; 


if (e.preventDefault) {
e.preventDefault();
} else {
e.returnValue = false;
}


if (e && e.stopPropagation) {
e.stopPropagation();
} else {
window.event.cancelBubble = true;
}


document.onmousemove = function (e) {
let length = e.clientX - mouseX;
if (length > maxRight) {
length = maxRight;
} else if (length < -maxLeft) {
length = -maxLeft;
}
let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.width;
let rate = (oriLeft + length) / pgsWidth;
audio.currentTime = audio.duration * rate;
that.updateProgress(audio);
};


document.onmouseup = function () {
document.onmousemove = null;
document.onmouseup = null;
};
}
},

audioPlay() {
let that = this;
let audio = document.getElementById("myaudio");

audio.addEventListener(
"timeupdate",
function () {
that.updateProgress(audio);
},
false
);


audio.addEventListener(
"ended",
function () {
that.audioEnded();
},
false
);


if (audio.paused) {

audio.play();
that.playing = true;
} else {
audio.pause();
that.playing = false;
}
},

updateProgress(audio) {
let value = audio.currentTime / audio.duration;
this.barWidth = value * 100;
this.dotLeft = value * 100;
this.audioCurTime = this.commonFun.transTime(audio.currentTime);
this.duration = this.commonFun.transTime(audio.duration);
},

audioEnded() {
this.barWidth = 0;
this.dotLeft = 0;
this.playing = false;
this.audioCurTime = "00:00";
},
},

created() {},

mounted() {
this.getDetail();
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/scenicPoiDetail.vue